import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { observer, Provider } from 'mobx-react'
import DocumentTitle from 'react-document-title'

import ProjectPage from '@root/Project/ProjectPage'
import ProjectSearchPanel from './ProjectSearchPanel'

import ProjectSearchStore from './projectSearch.store'

class ProjectSearch extends Component {
  constructor (props) {
    super(props)
    this.projectSearchStore = new ProjectSearchStore()
  }

  render () {
    return (
      <Provider projectSearchStore={this.projectSearchStore}>
        <DocumentTitle title='Project search and listing | Atheneum Partners'>
          <div className='expert-search'>
            <ProjectSearchPanel />
            <div className='expert-search-results'>
              <Route
                path='/project-search/project/:id'
                component={ProjectPage}
              />
            </div>
          </div>
        </DocumentTitle>
      </Provider>
    )
  }
}

export default observer(ProjectSearch)
